module.exports = __webpack_public_path__ + "img/sem-multa.a03b7007.svg";